'use client'
import type { ReactNode } from 'react'
import { ConsentProvider } from '@/services/components/strategies/privacy/ConsentContext'
import { AppProvider } from '@/context/AppContext'

export interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: Readonly<ProvidersProps>) {
  return (
    <AppProvider value={{}}>
      <ConsentProvider>{children}</ConsentProvider>
    </AppProvider>
  )
}
